<template>
    <div class="list-table-pc standard">
        <div class="show_data" v-show="showRecentListingData">
            <div class="list">
                <!-- table title start -->
                <div class="titile list_item">
                    <div class="cell image">
                        {{ $ft.uppercase($t('md-listing-list.image')) }}
                    </div>
                    <div class="cell address">
                        {{ $ft.uppercase($t('md-listing-list.address')) }}
                    </div>
                    <div class="cell sold_data">
                        {{
                            $ft.uppercase(
                                isSoldListing
                                    ? $t('md-listing-list.soldDate')
                                    : $t('md-listing-list.listingDate')
                            )
                        }}
                    </div>
                    <div class="cell property_type">
                        {{ $ft.uppercase($t('md-listing-list.propertyType')) }}
                    </div>
                    <div class="cell configure">
                        {{ $ft.uppercase($t('md-listing-list.configuration')) }}
                    </div>
                    <div class="cell t_right">
                        {{
                            $ft.uppercase(isSoldListing ? $t('md-listing-list.sold_price') : $t('md-listing-list.listing_price'))
                        }}
                    </div>
                </div>
                <table-item
                    v-for="item in listing"
                    :key="item.id"
                    :params="item"
                ></table-item>
                <!-- table title end -->
            </div>
            <Pagination
                v-if="!showLock"
                :totalPage="totalPage"
                :pageSize="pageSize"
                :pageNum="pageNum"
                :noScroll="true"
                @pageChange="onPageChange"
            />
            <div class="loading_container" v-show="showRecentListingLoading">
                <Loading />
            </div>
        </div>
        <div class="coming_container" v-show="showRecentListingComing">
            <img
                class="pic"
                src="//static.chimeroi.com/image/snapshot/v3-img-no-listing@2x.png"
                alt
            />
            <div class="desc">{{ $t('md-listing-list.comingSoon') }}</div>
        </div>
        <div class="no_data" v-show="showRecentListingNoData">
            <img
                class="pic"
                src="//static.chimeroi.com/image/snapshot/v3-img-no-listing@2x.png"
                alt
            />
            <div class="desc">{{ $t('md-listing-list.noData') }}</div>
        </div>
    </div>
</template>

<script>
import { mapState as rootMapState } from 'pinia';
import { mapState } from '@/store/helpers';
import { usePageStore } from '@/store';
import { defineAsyncComponent } from 'vue';
import paginationMixins from '../../../_mixins/pagination/common';

import Loading from '../../../../../components/loading';
import TableItem from '../table-item/pc';

export default {
    name: 'list-table-pc',
    components: {
        Pagination: defineAsyncComponent(() =>
            import(
                /* webpackChunkName: "components/pagination"*/ '@/components/pagination/index.vue'
            )),
        Loading,
        'table-item': TableItem
    },
    props: {
        showLock: {
            type: Boolean,
            default: false
        }
    },
    mixins: [paginationMixins],
    computed: {

        ...rootMapState(usePageStore, {
            "showSoldPrice": store => store.page?.house?.showSoldPrice
        }),

        ...mapState({
            "showRecentListingComing": "showRecentListingComing",
            "showRecentListingNoData": "showRecentListingNoData",
            "showRecentListingLoading": "showRecentListingLoading",
            "showRecentListingData": "showRecentListingData",
            "isSoldListing": "isSoldListing"
        }),
        showPrice() {
            return (
                !this.isSoldListing ||
                (this.isSoldListing && this.showSoldPrice)
            );
        }
    }
};
</script>

<style lang="scss">
.list-table-pc.standard{
    .show_data {
        .pagination {
            margin-bottom: 20px;
        }
    }
    .list {
        width: 100%;
        padding: 0 30px;
        display: table;
        font-family: var(--font-normal);
        /* table layout structure and title The style settings for  start */
        .list_item {
            display: table-row;
            justify-content: space-between;
            &.titile {
                font-family: var(--font-normal);
                font-size: 14px;
                line-height: 1;
                color: var(--color-disable);
                .cell {
                    padding-top: 26px;
                }
                .image {
                    width: 190px;
                }
                .address {
                    width: 205px;
                }
                .sold_data {
                    width: 115px;
                }
                .property_type {
                    width: 170px;
                }
                .configure {
                    width: 130px;
                }
            }
            .cell {
                display: table-cell;
            }
            .t_right {
                text-align: right;
            }
        }
        /* table layout structure and title The style settings for  end */
    }
    .show_data {
        position: relative;
        .loading_container {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            z-index: var(--level-low);
            background: rgba(255, 255, 255, 0.6);
            display: flex;
            justify-content: center;
            align-items: center;
            min-height: 100px;
        }
    }
    .coming_container,
    .no_data {
        width: 100%;
        padding-top: 60px;
        padding-bottom: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .pic {
            width: 220px;
            height: 130px;
        }
        .desc {
            margin-top: 20px;
            font-size: 16px;
            padding: 0 20px;
            text-align: center;
            color: var(--color-holder);
        }
    }
}
</style>
